import { NgbTimeStruct, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';


export interface NgbDateTimeStruct extends NgbDateStruct, NgbTimeStruct { }

export class DateTimeModel implements NgbDateTimeStruct {
    year: number;
    month: number;
    day: number;
    hour: number;
    minute: number;
    second: number;
   // ampm: string;

  

    timeZoneOffset: number;
 

    public constructor(
         init?: Partial<DateTimeModel>
         ) {
        Object.assign(this, init);
    }
   
    public static fromLocalString(dateString: any): DateTimeModel {
        console.log(dateString);
        var str: any=+dateString;
        var p= new DatePipe('en-ca').transform(new Date(dateString), 'yyyy-MM-dd hh:mm:ss a');
        let d=new DatePipe('en-ca').transform(dateString, 'yyyy-MM-dd hh:mm:ss a');
        console.log(d);
        console.log(new Date(dateString).getUTCDate());
        console.log(new Date(p).getUTCDate());
        console.log(new Date(dateString).getHours());
        console.log(new Date(dateString).getDate())
       // const date = new Date(dateString+' 00:00');
       //const datee = new Date(dateString); 
       const datee = new Date(d);
       console.log(datee);
    //const datee=new Date(dateString).getUTCDate();
       const date= new Date(datee.getUTCFullYear(),
       datee.getUTCMonth(),
       datee.getUTCDate(),
       datee.getHours(),
       datee.getUTCMinutes(),
       datee.getUTCSeconds());
       console.log(date.getDate()); 
       /**const date= new Date(d.getUTCFullYear(),
       d.getUTCMonth(),
       datee.getUTCDate(),
       datee.getHours(),
       datee.getUTCMinutes(),
       datee.getUTCSeconds());**/
       console.log(date.getDate()); 
console.log(date.toISOString());
console.log(datee.getDate());
        const isValidDate = !isNaN(date.valueOf());

        if (!dateString || !isValidDate) {
            return null;
        }

        return new DateTimeModel({
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: datee.getDate(),
            hour: date.getHours(),
            minute: date.getMinutes(),
            second: date.getSeconds(),
          //  ampm: date.getampm(),
          timeZoneOffset: date.getTimezoneOffset()
        });
    }

    private isInteger(value: any): value is number {
        return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
    }

    public toString(): string {
        if (this.isInteger(this.year) && this.isInteger(this.month) && this.isInteger(this.day)) {
            const year = this.year.toString().padStart(2, '0');
            const month = this.month.toString().padStart(2, '0');
            const day = this.day.toString().padStart(2, '0');

            if (!this.hour) {
                this.hour = 0;
            }
            if (!this.minute) {
                this.minute = 0;
            }
            if (!this.second) {
                this.second = 0;
            }
            if (!this.timeZoneOffset) {
                this.timeZoneOffset = new Date().getTimezoneOffset();
            }

            const hour = this.hour.toString().padStart(2, '0');
            const minute = this.minute.toString().padStart(2, '0');
            const second = this.second.toString().padStart(2, '0');

            const tzo = -this.timeZoneOffset ;
            console.log(tzo);
            const dif = tzo >= 0 ? '+' : '-',
            pad = function(num) {
                const norm = Math.floor(Math.abs(num));
                return (norm < 10 ? '0' : '') + norm;
            };

//const formatdate= this.datepipe.transform('yyyy-M-d h:mm a')
            const isoString = `${pad(year)}-${pad(month)}-${pad(day)} ${pad(hour)}:${pad(minute)} `;//:${pad(second)}${dif}${pad(tzo / 60)}:${pad(tzo % 60)}`;
            console.log(isoString);
            return isoString;
        }

        return null;
    }
}

